import { render, staticRenderFns } from "./VideoSurveillance.vue?vue&type=template&id=3054f70c&scoped=true"
import script from "./VideoSurveillance.vue?vue&type=script&lang=js"
export * from "./VideoSurveillance.vue?vue&type=script&lang=js"
import style0 from "./VideoSurveillance.vue?vue&type=style&index=0&id=3054f70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054f70c",
  null
  
)

export default component.exports